import React from 'react'
import DocumentViewer from '../../Component/DynamicDocViewer/Doc_Viewer'

const UgcPageView = () => {
  const UGCDocument = {
    pathurl: 'dbradc/UGC Undertaking/UGC UNDERTAKING.pdf',
    filename: 'UGC Undertaking',
  }
  return (
    <div>
      <DocumentViewer selectedDocData={UGCDocument} />
    </div>
  )
}

export default UgcPageView
